import { render, staticRenderFns } from "./TipoProposta.vue?vue&type=template&id=3dc62fff&"
import script from "./TipoProposta.vue?vue&type=script&lang=js&"
export * from "./TipoProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports